import requestNews from '../../utils/request/indexNews.js'
//新闻列表
export function getNews(data) {
  return requestNews({
    url:'/api/portal/news/list',
    method: 'get',
    params: data
  })
}
//新闻详情
export function getNewsInfo(id) {
    return requestNews({
      url:`/api/portal/news/${id}`,
      method: 'get',
    })
  }
//附件下载
export function downloadOss(ossId) {
  return requestNews({
    url: `/system/oss/downloadWithoutAuth/${ossId}`,
    method: 'get',
    responseType: 'blob'
  })
}